<template>
  <v-container fluid>
    <!-- Unexpected Error -->
    <template v-if="errorText.length > 0">
      <v-card>
        <v-row justtify="center">
          <v-list-item>
            <v-list-item-content>
              <span class="headline">An error occurred</span>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon medium>
                sentiment_very_dissatisfied
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-row>
        <v-row justtify="center">
          <p class="caption">
            {{ errorText }}
          </p>
        </v-row>
      </v-card>
    </template>

    <template v-else>

      <!-- Nothing imported -->
      <v-row justify="center" v-if="items.length === 0 && !isImporting">
        <v-card>
          <v-list-item>
            <v-list-item-content>
              <h3 class="headline text-center">
                Nothing imported
              </h3>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon medium>
                sentiment_dissatisfied
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </v-row>

      <!-- Imported -->
      <template v-else>
        <v-toolbar v-if="importCount !== null" flat>
          <v-chip class="elevation-1 mr-2" dark :color="appColor_Medium">Staged: {{ stageCount }}</v-chip>
          <v-chip class="elevation-1 mr-2" dark :color="appColor_Medium">Imported: {{ importCount }}</v-chip>
          <v-chip class="elevation-1" dark :color="appColor_Medium">Omitted: {{ stageCount - importCount }}</v-chip>
          <!-- <v-chip class="caption">Calves: {{ calfCount }}</v-chip>
          <v-chip class="caption">Dams: {{ damCount }}</v-chip>
          <v-chip class="caption">Sires: {{ sireCount }}</v-chip>
          <v-chip class="caption">Steers: {{ steerCount }}</v-chip> -->
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="items"
          :loading="isImporting"
          :no-data-text="noDataText"
          item-key="herdName"
          class="elevation-1"
          hide-default-footer=""
          >
          <v-progress-linear v-slot:progress :color="appColor_Progress" indeterminate />
        </v-data-table>
      </template>
    </template>
  </v-container>
</template>

<script>
import { AppColor } from '@/config.js'

export default {
  name: 'HxImportResult',
  props: {
    importResult: {
      type: Object,
      default: null
    },
    isImporting: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: null
    },
  },
  data () {
    return {
      appColor_Light: AppColor.Light,
      appColor_Medium: AppColor.Medium,
      appColor_Progress: AppColor.Progress,

      headers: [
        {
          text: 'Herd',
          value: 'herdName',
          align: 'left',
          width: '60%'
        },
        {
          text: 'Calves',
          value: 'calfCount',
          align: 'right',
          width: '10%'
        },
        {
          text: 'Dams',
          value: 'damCount',
          align: 'right',
          width: '10%'
        },
        {
          text: 'Sires',
          value: 'sireCount',
          align: 'right',
          width: '10%'
        },
        {
          text: 'Steers',
          value: 'steerCount',
          align: 'right',
          width: '10%'
        }
      ]
    }
  },
  computed: {
    items: function () {
      if (this.importResult === null) {
        return []
      }
      return this.importResult.herdImports
    },
    noDataText () {
      if (this.isImporting) return 'Importing...'

      return this.importResult.herdImports.length === 0
        ? 'No results found'
        : ''
    },
    importCount: function () {
      if (this.importResult === null) {
        return null
      }
      return this.importResult.importCount
    },
    stageCount: function () {
      if (this.importResult === null) {
        return null
      }
      return this.importResult.stageCount
    },
    // calfCount: function () {
    //   if (this.importResult === null) {
    //     return null
    //   }
    //   return this.importResult.calfCount
    // },
    // damCount: function () {
    //   if (this.importResult === null) {
    //     return null
    //   }
    //   return this.importResult.damCount
    // },
    // sireCount: function () {
    //   if (this.importResult === null) {
    //     return null
    //   }
    //   return this.importResult.sireCount
    // },
    // steerCount: function () {
    //   if (this.importResult === null) {
    //     return null
    //   }
    //   return this.importResult.steerCount
    // }
  }
}
</script>
